module.exports = __webpack_public_path__ + "static/media/mstile-150x150.2c700319.png";